import "./pOvertimeApplications/pOvertimeApplications.sass";
import "./bOvertimeApplicationForm/bOvertimeApplicationForm.sass";
import "./bOvertimeApplicationsTable/bOvertimeApplicationsTable.sass";
import "./bWorklogsTable/bWorklogsTable.sass";

import {pOvertimeApplicationsDirective} from "./pOvertimeApplications/pOvertimeApplications.directive";
import {bOvertimeApplicationFormDirective} from "./bOvertimeApplicationForm/bOvertimeApplicationForm.directive";
import {bOvertimeApplicationsTableDirective} from "./bOvertimeApplicationsTable/bOvertimeApplicationsTable.directive";
import { bWorklogsTableDirective } from "./bWorklogsTable/bWorklogsTable.directive";

import {OvertimeApplicationsService} from './OvertimeApplications.service';

export default angular.module('frontend.overtimeApplications', ["frontend.api", "frontend.auth", "frontend.theme", "jkuri.datepicker"])
  .directive('pOvertimeApplications', pOvertimeApplicationsDirective)
  .directive('bOvertimeApplicationForm', bOvertimeApplicationFormDirective)
  .directive('bOvertimeApplicationsTable', bOvertimeApplicationsTableDirective)
  .directive('bWorklogsTable', bWorklogsTableDirective)
  .service('OvertimeApplications', OvertimeApplicationsService);